export const docusignRoles: Record<
  DocusignRoleKey,
  {
    roleName: string;
    recipientId: string;
    description: string;
    required?: boolean;
  }
> = {
  applicationPreparer: {
    roleName: 'Application Preparer',
    recipientId: '1',
    description: 'The person who prepares the application for the client.',
    required: true,
  },
  advisor: {
    roleName: 'Advisor',
    recipientId: '2',
    description: 'The advisor working with the client.',
    required: true,
  },
  primaryInsured: {
    roleName: 'Primary Insured',
    recipientId: '3',
    description: 'The primary insured for the policy.',
    required: true,
  },
  secondaryInsured: {
    roleName: 'Secondary Insured',
    recipientId: '4',
    description: 'The secondary insured for the policy.',
  },
  policyOwner: {
    roleName: 'Policy Owner',
    recipientId: '5',
    description: 'The policy owner.',
    required: true,
  },
  jointOwner: {
    roleName: 'Joint Policy Owner',
    recipientId: '6',
    description: 'The joint policy owner.',
  },
  policyOwnerSpouse: {
    roleName: 'Policy Owner Spouse',
    recipientId: '7',
    description: 'The spouse of the policy owner.',
  },
  irrevocableBeneficiary: {
    roleName: 'Irrevocable Beneficiary',
    recipientId: '8',
    description: 'Beneficiary whose designation cannot be changed without their written consent.',
  },
  agent2: {
    roleName: 'Agent 2',
    recipientId: '9',
    description: 'Second agent.',
  },
  agent3: {
    roleName: 'Agent 3',
    recipientId: '10',
    description: 'Third agent.',
  },
  residentAgent: {
    roleName: 'Resident Agent',
    recipientId: '11',
    description: 'Resident agent for California applications.',
  },
  primaryInsuredSpouse: {
    roleName: 'Primary Insured Spouse',
    recipientId: '12',
    description: 'Primary Insured Spouse for California applications.',
  },
  legalRepresentative: {
    roleName: 'Legal Representative',
    recipientId: '13',
    description: 'Legal Representative for California applications.',
  },
  collateralAssignee: {
    roleName: 'Collateral Assignee',
    recipientId: '14',
    description: 'Collateral assignee for the policy.',
  },
  fieldPrincipal: {
    roleName: 'Field Principal',
    recipientId: '15',
    description: 'Field principal signature for Securian applications.',
  },
  homeOffice: {
    roleName: 'Home Office',
    recipientId: '16',
    description: 'Home office representative signature for Securian applications.',
  },
  policyOwnerAuthRepresentative1: {
    roleName: 'First Authorized Representative',
    recipientId: '18',
    description: 'First authorized representative signature for Securian applications.',
  },
  policyOwnerAuthRepresentative2: {
    roleName: 'Second Authorized Representative',
    recipientId: '19',
    description: 'Second authorized representative signature for Securian applications.',
  },
  policyOwnerAuthRepresentative3: {
    roleName: 'Third Authorized Representative',
    recipientId: '20',
    description: 'Third authorized representative signature for Securian applications.',
  },
  legalCounsel: {
    roleName: 'Actuary / Legal Counsel',
    recipientId: '21',
    description: 'Actuary / Legal Counsel signature for Securian applications.',
  },
  secretary: {
    roleName: 'Company’s Secretary',
    recipientId: '22',
    description: 'Company’s Secretary signature for Securian applications.',
  },
  replacementPolicyAdvisor: {
    roleName: 'Advisor of policy being replaced',
    recipientId: '23',
    description: 'Advisor of policy being replaced signature for Securian applications.',
  },
  captiveOfficer: {
    roleName: 'Captive’s officer',
    recipientId: '24',
    description: 'Captive’s officer signature for Securian applications.',
  },
  trustee1: {
    roleName: 'First Trustee',
    recipientId: '25',
    description: 'First Trustee signature for Securian applications.',
  },
  trustee2: {
    roleName: 'Second Trustee',
    recipientId: '26',
    description: 'Second Trustee signature for Securian applications.',
  },
  trustee3: {
    roleName: 'Third Trustee',
    recipientId: '27',
    description: 'Third Trustee signature for Securian applications.',
  },
  authorizedRepresentative: {
    roleName: 'Authorized Representative with financial authorization',
    recipientId: '28',
    description: 'Authorized Representative signature for Securian applications.',
  },
  companyAdmin: {
    roleName: 'Company administrator with financial authorization',
    recipientId: '29',
    description: 'Company administrator signature for Securian applications.',
  },
  authorizedMember: {
    roleName: 'Authorized Partner/Member',
    recipientId: '30',
    description: 'Authorized Partner/Member signature for Securian applications.',
  },
  personalRepresentative: {
    roleName: 'Personal Representative',
    recipientId: '31',
    description: 'Personal representative signature for Securian applications HIPAA Authorization.',
  },
  policyOwnerPartnerOrMember1: {
    roleName: 'First Partner/Member',
    recipientId: '32',
    description: 'First partner/member signature for Securian applications.',
  },
  policyOwnerPartnerOrMember2: {
    roleName: 'Second Partner/Member',
    recipientId: '33',
    description: 'Second partner/member signature for Securian applications.',
  },
  policyOwnerPartnerOrMember3: {
    roleName: 'Third Partner/Member',
    recipientId: '34',
    description: 'Third partner/member signature for Securian applications.',
  },
  policyOwnerPartnerOrMember4: {
    roleName: 'Fourth Partner/Member',
    recipientId: '35',
    description: 'Fourth partner/member signature for Securian applications.',
  },
  applicantPartner: {
    roleName: 'Applicant Partner',
    recipientId: '36',
    description: 'Applicant partner (Proposed Insured B) signature for Lincoln applications.',
  },
};
